import { useEffect, useState } from "react";
import { fetchVendorCollections } from "../lib/storefront";
import type { Collection, PocaConfig } from "../types";

type State = {
  collections: Collection[];
  loading: boolean;
  error: string | null;
};

export function useVendorCollections(config: PocaConfig) {
  const [state, setState] = useState<State>({
    collections: [],
    loading: true,
    error: null,
  });

  useEffect(() => {
    const ac = new AbortController();
    let cancelled = false;

    console.log("[poca] useVendorCollections — loading", {
      prefix: config.collectionTitlePrefix,
      vendor: config.vendor,
    });
    setState({ collections: [], loading: true, error: null });

    fetchVendorCollections(config, ac.signal)
      .then((collections) => {
        if (cancelled) return;
        console.log("[poca] useVendorCollections — success", {
          count: collections.length,
          ids: collections.map((c) => c.id),
        });
        setState({ collections, loading: false, error: null });
      })
      .catch((e) => {
        if (cancelled || ac.signal.aborted) {
          console.log("[poca] useVendorCollections — aborted");
          return;
        }
        console.error("[poca] useVendorCollections — error", e);
        setState({
          collections: [],
          loading: false,
          error: e instanceof Error ? e.message : "Failed to load collections",
        });
      });

    return () => {
      cancelled = true;
      ac.abort();
      console.log("[poca] useVendorCollections — cleanup (abort)");
    };
  }, [config]);

  return state;
}
